import { gql } from "@apollo/client";

export const GET_CUMPLIMIENTO_EVALUACION = gql`
query GetCumplimientoEvaluacion($idEvaluacion: Int!, $from: CustomDateTime!, $to: CustomDateTime!) {
    calcularPorcentajeCumplimiento(idEvaluacion: $idEvaluacion, from: $from, to: $to) {
        key
        value
    }  
}`;

export const adaptCumplimiento = (cumplimientoArray) => {
  if (!cumplimientoArray || !Array.isArray(cumplimientoArray)) {
    return {};
  }

  return cumplimientoArray.reduce((acc, item) => {
    acc[item.key] = Number(item?.value?.toFixed(2));
    return acc;
  }, {});
};